import React, { useState, useEffect } from "react";
import { Row, Col, Table, Empty, Spin } from "antd";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import { BarsOutlined } from "@ant-design/icons";

const DbsDealerVolumeReport = (props) => {
  const [tableData, setWidgetData] = useState({
    data: [],
    loading: true,
  });
  const [detailTableData, setDetailTableData] = useState({});

  useEffect(() => getData(), []);

  const getData = () => {
    const url = props.dataUrl ? props.dataUrl : "/DbsDashboard/HighestFirmVolumeReport";

    RequestHandler.get(url).then((response) => {
      setWidgetData({
        data: response.data,
        loading: false,
      });
    });
  };

  const renderCurrencyFormat = (data) => (
    <CurrencyFormat
      value={data}
      displayType={"text"}
      decimalSeparator={","}
      thousandSeparator={"."}
      prefix={"₺"}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  )

  const renderRowDetail = (rowId) => {
    const detail = detailTableData[rowId];

    if (!detail) return null;

    const detailColumns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        render: (text, row, index) => {
          return (
            <div style={{ width: 100 }}>
              <img src={text}></img>
            </div>
          );
        },
      },
      {
        title: "Bayi Kodu",
        dataIndex: "code",
      },
      {
        title: "Son 12 Ay Toplam",
        dataIndex: "total",
        render: renderCurrencyFormat,
      },
      {
        title: "Bugün",
        dataIndex: "today",
        render: renderCurrencyFormat,
      },
      {
        title: moment().format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "0"],
        render: renderCurrencyFormat,
      },
      {
        title: moment().add(-1, "month").format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "1"],
        render: renderCurrencyFormat,
      },
      {
        title: moment().add(-2, "month").format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "2"],
        render: renderCurrencyFormat,
      },
      {
        title: moment().add(-3, "month").format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "3"],
        render: renderCurrencyFormat,
      },
      {
        title: moment().add(-4, "month").format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "4"],
        render: renderCurrencyFormat,
      },
      {
        title: moment().add(-5, "month").format("MMMM YY"),
        dataIndex: ["xMonthAgoTotal", "5"],
        render: renderCurrencyFormat,
      },
    ];

    return detail.loading ? (
      <Row justify="center">
        <Spin style={{ margin: 5 }} />
      </Row>
    ) : (
      <Table
        columns={detailColumns}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Veri Yok"
            />
          ),
        }}
        rowKey="code"
        filterable={true}
        sortable={true}
        pageable={true}
        pagination={{
          defaultPageSize: 20,
          hideOnSinglePage: true,
          pageSizeOptions: ["20"],
          total: detail.data.length,
        }}
        dataSource={detail.data}
        size="small"
      />
    );
  };

  const onExpand = (expanded, row) => {
    if (!expanded) return;

    setDetailTableData((prevState) => {
      prevState[row.firmId] = {
        data: [],
        loading: true,
      };
      return prevState;
    });

    const url = (props.dataUrl ? props.dataUrl : "/DbsDashboard/HighestFirmVolumeReport") + "/" + row.firmId;
    RequestHandler.get(url).then((response) => {

      setDetailTableData((prevState) => {
        let newState = { ...prevState };
        newState[row.firmId] = {
          data: Array.isArray(response.data) ? response.data : prevState.data,
          loading: false,
        };
        return newState;
      });

    });
  };

  const columns = [
    {
      title: "Bayi Adı",
      dataIndex: "firmName",
    },
    {
      title: "Bayi Kodu",
      dataIndex: "firmCode",
    },
    {
      title: "Son 12 Ay Toplam",
      dataIndex: "total",
      render: renderCurrencyFormat,
    },
    {
      title: "Bugün",
      dataIndex: "today",
      render: renderCurrencyFormat,
    },
    {
      title: moment().format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "0"],
      render: renderCurrencyFormat,
    },
    {
      title: moment().add(-1, "month").format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "1"],
      render: renderCurrencyFormat,
    },
    {
      title: moment().add(-2, "month").format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "2"],
      render: renderCurrencyFormat,
    },
    {
      title: moment().add(-3, "month").format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "3"],
      render: renderCurrencyFormat,
    },
    {
      title: moment().add(-4, "month").format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "4"],
      render: renderCurrencyFormat,
    },
    {
      title: moment().add(-5, "month").format("MMMM YY"),
      dataIndex: ["xMonthAgoTotal", "5"],
      render: renderCurrencyFormat,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CİROSU EN YÜKSEK BAYİLER
          </p>
        </Col>
        <Col xs={8}>
        </Col>
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (row) => renderRowDetail(row.firmId),
              onExpand: onExpand,
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="firmId"
            filterable={true}
            sortable={true}
            pageable={true}
            pagination={{
              defaultPageSize: 15,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.data.length,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default DbsDealerVolumeReport;
